var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BottomPopup',{attrs:{"show":_vm.showGradeSelect},on:{"right-icon-handler":_vm.onConfirm,"left-icon-handler":_vm.handleCancel}},[_c('template',{slot:"custom-body"},[_c('div',[_c('van-picker',{attrs:{"columns":_vm.gradeList,"default-index":_vm.currentSelectedIndex,"value-key":"name"},on:{"change":_vm.changeHandler}})],1)])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }